// extracted by mini-css-extract-plugin
module.exports = {"backButtonText":"back-button_backButtonText__V455h","backButtonIcon":"back-button_backButtonIcon__m_WZb"};